import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { IonTextarea } from '@ionic/angular/standalone';

import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
    selector: 'lib-textarea',
    standalone: true,
    imports: [CommonModule, IonTextarea, InputWrapperComponent, ReactiveFormsModule],
    templateUrl: './textarea.component.html',
    styleUrl: './textarea.component.css'
})
export class TextareaComponent implements OnInit {
    /* eslint-disable */
    @Input() label: string = '';
    @Input() hideLabel: boolean = false;
    @Input() helperText: string | undefined = '';
    @Input() errorText: string | undefined = '';
    @Input() placeholder?: string = '';
    @Input() form: FormGroup = new FormGroup({
        input: new FormControl('')
    });
    @Input() controlName: string = 'input';
    @Input() required: boolean = false;
    @Input() submitAttempt: boolean = false;
    @Input() rows: number = 8;
    @Input() ionItemWrap = true; //wrap form in ion-item
    @Input() autoGrow: boolean = false;

    formInput: AbstractControl | null = null;

    constructor() {}

    ngOnInit() {
        if (this.controlName) {
            this.formInput = this.form?.controls[this.controlName];
        }
    }
}
